// @flow
import {useContext} from 'react';
import {MobXProviderContext} from 'mobx-react';
import type {StoresType} from 'mobx/RootStore';

export function useStores(): StoresType {
  return useContext(MobXProviderContext);
}
